// give servicing that should be added then added to damages to create costs
import _ from 'lodash';
import moment from 'moment';
import createDamage from './createDamage';
import addAlert from './addAlert';

// zone to which add the damages generate
const zoneName = 'servicing';

/// //////// CONSTANTS FOR CALCULATION---> ///////////
// age for the vehicle to switch (in months)
const recentVehicleMaxAge = 114;
// minimum numbers of months before the end of TC - otherwise we do it
const technicalCheckValidity = 12;
// max months from last servicing for old cars before it' alert:
const alertOldServicing = 24;
// max km since the last revision
const maxKmSinceLastServicing = 10000;
// max months since the last revision
const maxMonthsSinceLastServicing = 6;

/// //////// <---CONSTANTS FOR CALCULATION ///////////

const now = moment();

function addDamage(element, value, damages) {
  const damage = {
    zone: zoneName,
    element,
    value,
  };
  damages.push(createDamage(damage));
}

// Mois depuis dernière révision (date jour – date dernière révision)	KM depuis dernière révision	Décision
// < 6 mois	>= 10 000	Révision
// < 6 mois	< 10.000 km	Pas de révision
// >= 6 mois		Révision

function getMonthsToNextTechnicalCheck(next_technical_check_date) {
  if (next_technical_check_date === undefined) return null;
  const _next_technical_check_date = moment(next_technical_check_date, 'YYYY-MM-DD');
  let monthsToNextTechnicalCheck = _next_technical_check_date.diff(now);
  monthsToNextTechnicalCheck = moment.duration(monthsToNextTechnicalCheck).asMonths();
  return monthsToNextTechnicalCheck;
}

function getMonthsFromLastServicing(last_servicing_date) {
  if (last_servicing_date === undefined) return null;
  const _last_servicing_date = moment(last_servicing_date, 'YYYY-MM-DD');
  let getMonthsDateFromLastServicing = now.diff(_last_servicing_date);
  getMonthsDateFromLastServicing = moment.duration(getMonthsDateFromLastServicing).asMonths();
  return getMonthsDateFromLastServicing;
}

function vehicleAge(dateOfRelease) {
  const _dateOfRelease = moment(dateOfRelease, 'YYYY-MM-DD');
  let age = now.diff(_dateOfRelease);
  age = moment.duration(age).asMonths();
  return age;
}

function calculateTechnicalCheck(servicingInfos, vehicleInfos, damages, report) {
  // console.log("vehicleInfos",vehicleInfos)

  if (
    !Object.prototype.hasOwnProperty.call(servicingInfos, 'next_technical_check_date') ||
    !Object.prototype.hasOwnProperty.call(servicingInfos, 'last_servicing_date')
  )
    return;

  const next_technical_check_date = _.get(servicingInfos, 'next_technical_check_date[1]');
  const last_servicing_date = _.get(servicingInfos, 'last_servicing_date[1]');
  const dateOfRelease = _.get(vehicleInfos, 'registrationDate[1]');

  const monthsToNextTechnicalCheck = getMonthsToNextTechnicalCheck(next_technical_check_date);
  const age = vehicleAge(dateOfRelease);

  if (monthsToNextTechnicalCheck > technicalCheckValidity) return;
  addDamage('technical_check', 'to_do', damages);

  // add alerts about technical check
  if (monthsToNextTechnicalCheck === null) {
    addAlert(report, 'unknown_next_technical_check_date');
    return;
  }

  if (monthsToNextTechnicalCheck < 0) {
    addAlert(report, 'technical_check_overdue');
    return;
  }

  if (age < recentVehicleMaxAge) {
    const months = Math.round(technicalCheckValidity);
    addAlert(report, `technical_check_in_less_than_${months}_months`);
    return;
  }

  const monthsFromLastServicing = getMonthsFromLastServicing(last_servicing_date);
  if (monthsFromLastServicing === null || monthsFromLastServicing > alertOldServicing) {
    addAlert(report, 'technical_check_vehicle_b2b');
  }
}

function calculateServicing(servicingInfos, vehicleInfos, damages) {
  if (
    !Object.prototype.hasOwnProperty.call(servicingInfos, 'last_servicing_km') ||
    !Object.prototype.hasOwnProperty.call(servicingInfos, 'last_servicing_date') ||
    !Object.prototype.hasOwnProperty.call(vehicleInfos, 'vehicule_test_mileage')
  )
    return;
  const last_servicing_km = _.get(servicingInfos, 'last_servicing_km[1]');
  const last_servicing_date = _.get(servicingInfos, 'last_servicing_date[1]');
  const vehicule_test_mileage = _.get(vehicleInfos, 'vehicule_test_mileage[1]');

  const monthsFromLastServicing = getMonthsFromLastServicing(last_servicing_date);
  // console.log("servicing data", vehicule_test_mileage, last_servicing_km)
  if (last_servicing_km === undefined || monthsFromLastServicing === null || vehicule_test_mileage === undefined) {
    addDamage('car_inspection', 'full', damages);
    return;
  }
  const km_since_last_servicing = vehicule_test_mileage - last_servicing_km;
  if (km_since_last_servicing < 0) {
    addDamage('car_inspection', 'full', damages);
    return;
  }
  _.set(servicingInfos, 'km_since_last_servicing', ['integer', km_since_last_servicing]);
  if (km_since_last_servicing < maxKmSinceLastServicing && monthsFromLastServicing < maxMonthsSinceLastServicing) {
    addDamage('car_inspection', 'ctrl_preparation_cost', damages);
    return;
  }
  addDamage('car_inspection', 'full', damages);
}

// -	Si (âge VO < 9 ans et 6 mois) ET (date prochain contrôle technique – date du jour)< 12 mois et > 6 mois, alors  ALERTE « CONTRÔLE TECHNIQUE -  12 mois »
// o	Pour le calcul des frevo : CT = OUI
// -	Si (âge VO < 9 ans et 6 mois) ET (date prochain contrôle technique – date du jour)<= 6 mois, alors  ALERTE « CONTRÔLE TECHNIQUE – 6 mois »
// o	Pour le calcul des frevo : CT = OUI
// -	Si (âge VO >= 9 ans et 6 mois) ET (date prochain contrôle technique – date du jour)< 12 mois ET date dernière révision > 24 mois OU Date dernier entretien non renseignée, alors  « ALERTE CONTRÔLE TECHNIQUE VEHICULE B2B »

// ALERTES DU CONTRÔLE TECHNIQUE

// -	Si date prochain contrôle technique – date du jour) < 0, alors ALERTE «  CONTROLE TECHNIQUE DEPASSE »
// -	Si (âge VO < 9 ans et 6 mois) ET (date prochain contrôle technique – date du jour)< 12 mois et > 6 mois, alors  ALERTE « CONTRÔLE TECHNIQUE -  12 mois »
// o	Pas d’action spécifique, mais vigilance de l’acheteur sur l’expertise

// -	Si (âge VO < 9 ans et 6 mois) ET (date prochain contrôle technique – date du jour)<= 6 mois, alors  ALERTE « CONTRÔLE TECHNIQUE – 6 mois »
// o	Compter le forfait CT dans les FREVO

// -	Si (âge VO >= 9 ans et 6 mois) ET (date prochain contrôle technique – date du jour)< 12 mois ET date dernière révision > 24 mois OU Date dernier entretien non renseignée, alors  ALERTE « CONTRÔLE TECHNIQUE VEHICULE B2B »
// o	Demander autorisation achat (des règles spécifiques sont en cours de négociation avec les enchérisseurs)

// CALCUL COURROIE:
// Faite , Pas faite , Chaine
// Si la répons est has_been_changed, ajouter une photo de la facture obligatoire

// Règle 1 : Véhicule >120 000 km ou > 5ans ET distribution_belt has_not_been_changed
// -> appliquer le coût de la grille

// Règle 2 : Véhicule > 100 000 km ou >4 ans ET distribution_belt has_not_been_changed
// -> appliquer 50% du coût de la grille

function calculateBeltReplacement(servicingInfos, vehicleInfos, damages) {
  if (!Object.prototype.hasOwnProperty.call(servicingInfos, 'distribution_belt_info')) return;
  const distribution_belt_info = _.get(servicingInfos, 'distribution_belt_info[1]', null);
  const dateOfRelease = _.get(vehicleInfos, 'registrationDate[1]');
  const age = vehicleAge(dateOfRelease);
  const vehicule_test_mileage = _.get(vehicleInfos, 'vehicule_test_mileage[1]');

  console.log('belt calculation', vehicule_test_mileage, age, distribution_belt_info);
  if (!distribution_belt_info || distribution_belt_info !== 'has_not_been_changed') return;
  if (vehicule_test_mileage < 100000 && age < 48) return;

  // Regle 1
  if (vehicule_test_mileage > 120000 || age > 60) {
    console.log('aplly rule 1');
    addDamage('distribution_belt', 'to_change', damages);
    return;
  }
  // Regle 2
  addDamage('distribution_belt', 'to_change_soon', damages);
}

// set async because will be through api in the future
export default async function getServicing(report) {
  const damages = [];
  const servicingInfos = _.get(report, 'display.servicing', {});
  const vehicleInfos = _.get(report, 'display.vehicle', {});

  calculateTechnicalCheck(servicingInfos, vehicleInfos, damages, report);
  calculateServicing(servicingInfos, vehicleInfos, damages);
  calculateBeltReplacement(servicingInfos, vehicleInfos, damages);
  return damages;
}
